import React from 'react';
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import {Link, NavLink } from "react-router-dom";
import {device} from "../components/Devices";
import Hamburger from "../components/Hamburger";
import {useState} from "react";



function Navigation({isOpen}) {

    let navigate = useNavigate();
    const [hamburgerOpen, setHamburgerOpen] = useState(false);

    function hamburgerToggle() {
        setHamburgerOpen(!hamburgerOpen);
    }

    function backHome() {
        let path = "/home";
        navigate(path);
    }

    const linkStyle = ({ isActive }) => {
        return {
            textDecoration: isActive ? "underline" : "none",
            color: "var(--mainTextColor)",
        }
    }

    return (

        <Outer_Container_App>
            <h1 onClick={backHome}>Port<span>folio.</span></h1>

            <div className="hamburger" onClick={hamburgerToggle}>
                <Hamburger isOpen={hamburgerOpen}/>
            </div>

            {hamburgerOpen ?

                <ul className="open_hamburger">

                    <li>
                        <NavLink
                            to={"/home"}
                            style={linkStyle}
                            onClick={!isOpen}
                        >
                            Home
                        </NavLink>
                    </li>


                    <li>
                        <NavLink
                            to={"/career"}
                            style={linkStyle}
                            onClick={!isOpen}
                        >
                            Career
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={"/agile"}
                            style={linkStyle}
                            onClick={!isOpen}
                        >
                            Agile
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={"/coding"}
                            style={linkStyle}
                            onClick={!isOpen}
                        >
                            Coding
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={"/brands"}
                            style={linkStyle}
                            onClick={!isOpen}
                        >
                            Brands
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={"/contact"}
                            style={linkStyle}
                            onClick={!isOpen}
                        >
                            Contact
                        </NavLink>
                    </li>


                </ul>

                :

                <ul className="normal_menu">

                    <li >
                        <NavLink
                            to={"/home"}
                            style={linkStyle}
                        >
                            Home
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={"/career"}
                            style={linkStyle}
                        >
                            Career
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={"/agile"}
                            style={linkStyle}
                        >
                            Agile
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={"/coding"}
                            style={linkStyle}
                        >
                            Coding
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={"/contact"}
                            style={linkStyle}
                        >
                            Contact
                        </NavLink>
                    </li>

                    <li>
                        <NavLink
                            to={"/brands"}
                            style={linkStyle}
                        >
                            Brands
                        </NavLink>
                    </li>


                </ul>

            }

        </Outer_Container_App>

    );
}

export default Navigation;

const Outer_Container_App = styled.div`

  width: auto;
  height: 100%;
  max-height: 80px;
  min-width: 100%;
  max-width: 320px;
  background-color: var(--mainBackGroundColor);
  color: var(--mainTextColor);
  padding: 6px;

  display: flex;
  justify-content: space-between;
  margin-top: 0px;
  //border: 1px solid black;
  position: absolute;
  

  @media ${device.mobileM} {
    max-width: 375px;
  }

  @media ${device.mobileL} {

    max-width: 425px;
    //min-width: 100%;

  }

  @media ${device.tablet} {

    max-width: 768px;
  }

  @media ${device.laptop} {

    max-width: 1024px;
  }


  @media ${device.laptopL} {
    max-widht: 1440px;
  }


  h1 {
    font-size: 35px;
    font-weight: lighter;
    cursor: pointer;
    //margin-left: 10px;

    @media ${device.mobileL} {
      font-size: 30px;
    }

    @media ${device.tablet} {

      font-size: 35px;
    }

    @media ${device.laptopL} {
      font-size: 60px;
      margin-left: 20px;
    }

  }

  span {
    color: var(--orange);
  }

  .hamburger {
    display: none;
    
    
    @media (max-width: 768px) {

      display: fixed;
      padding-top: 10px;
      margin-left: 12px;
      z-index: 15;
    

    }

  }

  .open_hamburger {
    //display: inline;
    background-color: var(--blackShadow);
    opacity: 0.9;
    z-index: 10;
    height: 914px;
    width: 100%;
    margin-top: 50px;
    position: absolute;
    right: 0;
    top: 0;
    list-style: none;
    font-size: 30px;
    padding: 10px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    
    

    li {
      margin-bottom: 40px;
      //color: var(--orange);
      
    }
    
    //makes the hamburger menu visible.../ or not

    @media (min-width: 800px) {
      display: none;
    }

  }

  .normal_menu {
    display: flex;
    list-style: none;
    margin-top: 2px;
    display: flex;
    flex-direction: column;
    
    //margin-right: -75px;

    @media (max-width: 768px) {
      display: none;
    }

    @media ${device.mobileL} {
      flex-direction: row;

    }

    @media ${device.tablet} {

      margin-top: 5px;
      font-size: 25px;
    }

    @media ${device.laptopL} {

      margin-top: 10px;
      font-size: 30px;
      margin-right: 20px;
    }


    li {
      margin-left: 10px;
      padding: 3px;
      
      
    }

  }


`;

